import * as Utils from '../utils/common-utils'

import { CSVProfile } from '../../types'
import { DoubleChartComponent } from '../charts/double-chart-component'
import { TRANSFORM_MILLI_TO_DATE } from '../commons/constants'
import angular from 'angular'

export class AFTwitterMetrics extends DoubleChartComponent {
    static config = {
        selector: 'afTwitterMetrics',
        controller: AFTwitterMetrics,
        bindings: DoubleChartComponent.config.bindings,
        template: DoubleChartComponent.config.template,
    }

    $onChanges(changes) {
        // // prepare double chart data
        // if (this.hasChanges(changes.vizData)) {
        //     this.prepareVisualizations(changes.vizData.extendedData);
        // }

        // prepare the CSV export data when data is changed
        this.buildCSVExportProfile();
    }

    buildCSVExportProfile() {
        // ensure data is reset, otherwise array data will grow
        this.csvExportProfiles = []

        let metricsExport: CSVProfile = {
            //cloning data to avoid mutation
            data: Object.assign({}, this.vizData.extendedData.metrics.data),
            csvOptions: { title: this.properties.title, headers: ['Category', 'Count'] },
            transformationProfiles: [],
        }

        let splineExport: CSVProfile = {
            data: Object.assign({}, this.vizData.extendedData.spline.data),
            csvOptions: { headers: ['Date', 'Count'], showTitle: false },
            transformationProfiles: [{ key: 'key', type: TRANSFORM_MILLI_TO_DATE }],
        }

        this.csvExportProfiles.push(metricsExport, splineExport)
    }
}
